import { Env } from '../../../core/env';
import { isSoloare } from '../../../core/models/js_env';
import { RootContainer } from '../../../core/root_container';
import { applyCarouselStyle } from '../../../core/views/common/carousel_util';
import { ItemJsEnv } from '../../models/item_js_env';
import { RrBodyItemExternalSite, RrBodyItemNormalLower, RrBodyItemNormalUpper } from './item_detail_rr_body';
import { loadingDisplayNone, removeLoading } from '../../../core/util/dom_util';

export class ItemDetailRrContainer extends RootContainer<ItemJsEnv> {
  constructor(model: ItemJsEnv) {
    super();

    if (isSoloare(Env.SITE_TYPE)) {
      this.mount(RrBodyItemExternalSite, model.rrAreaProfileItemExternalSite.placementName);
      this.mount(RrBodyItemNormalUpper, model.rrAreaProfileItemNormalUpper.placementName);
      this.mount(RrBodyItemNormalLower, model.rrAreaProfileItemNormalLower.placementName);

      // 初回描画
      this.update(model);

      const placementNameList = [
        model.rrAreaProfileItemExternalSite.placementName,
        model.rrAreaProfileItemNormalUpper.placementName,
        model.rrAreaProfileItemNormalLower.placementName
      ];

      const carouselIdList = placementNameList.map(placementName => placementName + "-carousel");
      applyCarouselStyle(carouselIdList);

    } else {
      if (model.isFromExternalSite) {
        // 外部流入の場合はタイマーを解除し、商品0件の場合はローディングモジュールを非表示とする
        clearTimeout(model.rrAreaProfileItemExternalSite.timeoutId);
        if (model.rrAreaProfileItemExternalSite.rrAreaItems.length === 0) {
          loadingDisplayNone(model.rrAreaProfileItemExternalSite.placementName);
        }
      }

      this.mount(RrBodyItemExternalSite, model.rrAreaProfileItemExternalSite.placementName);
      this.mount(RrBodyItemNormalUpper, model.rrAreaProfileItemNormalUpper.placementName);
      this.mount(RrBodyItemNormalLower, model.rrAreaProfileItemNormalLower.placementName);

      // 初回描画
      this.update(model);

      if (model.isFromExternalSite) {
        // 外部流入の場合ローディングクラスを削除する
        removeLoading(model.rrAreaProfileItemExternalSite.placementName);
      }

      const WindowCarousel = window._carousel;
      new WindowCarousel( // NOSONAR
        `#${model.rrAreaProfileItemExternalSite.placementName},#${model.rrAreaProfileItemNormalUpper.placementName},#${model.rrAreaProfileItemNormalLower.placementName}`
      );
    }
  }
}
